import React from "react";

export default function ComponentLoader() {
  return (
    <div className="d-flex justify-content-center align-item-center m-auto">
      <div className="spinner spinner-lg spinner-success" />
    </div>
  );
}
